import React, { Component, Fragment } from "react";
import "./style.scss";
import TabPlayer from "./tab";
import { Switch, Route } from "react-router-dom";
import BasicInfomation from "./basic-infomation";
import PerformanceByCondition from "./performance-by-condition";
import GameLogs from "./game-logs";
import PerformanceByYear from "./performance-by-year";
import PlayerAddTopic from "./add-topic";
import { forEach } from 'lodash';
import TeamUserTopic from './../team/team-user-topic/index';
import PlayerPitcher from "./player-pitcher";
import { connect } from "react-redux";
import { GetPlayerPitchers,  ACTIONS_PLAYER} from './../../../actions/player-pitchers';
import { detectIconById } from "../../../common/enum";
import { getSearchCommon, ACTIONS_SEARCH, getInfoPlayer} from './../../../actions/player-search';
import {ACTIONS_MASTER, getYearData} from './../../../actions/master';
import queryString from 'query-string';
import Loading from "../../../components/loading";

const ability = {
    "コンタクト率":"0.5",
    "ファーストストライクスイング率":"0.6",
    "ボールゾ ーンスイング率":"0.1",
    "ISO":"0.3",
    "盗塁成功率":"0.65",
    "打球速":"0.7"
};


class Player extends Component {

    constructor(props) {
        super(props);
        this.state = {
            rate: {
                contact: 10,
                ballZoneSwing: 30,
                stealSuccess: 50,
                firstStrikeSwing: 100,
                iso: 25,
                hittingSpeed: 99
            },
            player: {
                name: '',
                image: '',
                nickname: '',
                position: '',
                bloodGroup: '',
                height: '',
                weight: '',
                old: '',
                from: '',
                round: '',
                condition: '',
                status: '',
                ability: null
            },
            imgTeam: '',
            nickname: '',
            name: '',
            position: '',
            showLoading: false,
            playerInfo : null,
            listYear: null,
            dataPitcher1: null,
            dataPitcher2: null,
            dataHotzone: null,
            dataBallDirection: null
        }
    }

    navigateTeamReport() {
        this.props.history.push(`/team-report/${this.state.team_id}`);
    }

    componentDidMount() {
        this.setState({showLoading: true});
        // this.props.GetPlayerPitchers(1);
        let ovals = document.getElementsByClassName('oval');
        forEach(ovals, oval => {
            let percent = oval.getAttribute('data-percent')
            oval.style.left = `${percent}%`;
            oval.style.backgroundColor = percent < 33.33 ? "#3D3DF2" :
                percent < 66.66 ? "#6E7F8A" : "#FA3E3E"
        });
        const { search } = this.props.location;
        const param = queryString.parse(search);
        this.props.getSearchCommon(param.keyword);
        const player_id = this.props.match.params.id;

        this.props.getYearData();
        this.props.getInfoPlayer(player_id);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({showLoading: true});
        if (nextProps) {
            if (nextProps.status === ACTIONS_PLAYER.GET_HEADER_PLAYER_PITCHERS_SUCCESS) {
                let info = nextProps.response.common.deregistrations[0];
                this.setState({
                    imgTeam: detectIconById(info.player.team.id),
                    nickname: info.player.team.team_name_s,
                    name: info.player.player_name,
                    position: info.player.position_type,
                });
            }

            if (nextProps.status === ACTIONS_SEARCH.GET_INFO_PLAYER_SUCCESS) {
                let result = nextProps.response;

                this.setState({
                    showLoading: false,
                    name: nextProps.response.player_name,
                    imgTeam: nextProps.response.team ? detectIconById(nextProps.response.team.id): "",
                    nickname: nextProps.response.team ? nextProps.response.team.team_name_s : null,
                    position: nextProps.response.position_type_name,
                    team_id: nextProps.response.team ? nextProps.response.team.id : null,
                    player: {
                        bloodGroup: (nextProps.response.register_throw_lr ? nextProps.response.register_throw_lr : nextProps.response.real_throw_lr ? nextProps.response.real_throw_lr : ''
                        ) + (nextProps.response.register_bat_lr ? nextProps.response.register_bat_lr : nextProps.response.real_bat_lr ? nextProps.response.real_bat_lr : '') || '',
                        height: nextProps.response.height || '',
                        weight: nextProps.response.weight || '',
                        old: nextProps.response.age || '',
                        from: nextProps.response.career || '',
                        round: nextProps.response.draft_year ? nextProps.response.draft_year + "年" + nextProps.response.draft_round : "",
                        condition: nextProps.response.condition || '',
                        status: nextProps.response.comeback || '',
                        ability: nextProps.response.ability ? nextProps.response.ability : '',
                    },
                    playerInfo: result.playerInfo
                })
            }

            if (nextProps.status === ACTIONS_MASTER.GET_YEAR_SUCCESS) {
                const newState = (this.props.location.pathname.match(/\/player\/\d+$/)) ? {listYear: nextProps.response} : {
                    showLoading: false,
                    listYear: nextProps.response
                }
                this.setState(newState);
            }

            if (nextProps.status === ACTIONS_SEARCH.GET_INFO_PLAYER_PITCHER_BALL_TYPE_PERFORMANCES_SUCCESS) {
                this.setState({
                    showLoading: false,
                    dataPitcher1: nextProps.response
                })
            }
            if (nextProps.status === ACTIONS_SEARCH.GET_INFO_PLAYER_PITCHER_ORDINARY_HITS_SUMMARIES_SUCCESS) {
                this.setState({
                    showLoading: false,
                    dataPitcher2: nextProps.response
                })
            }
            if (nextProps.status === ACTIONS_SEARCH.GET_INFO_PLAYER_BATTER_HOTZONE_SUCCESS) {
                this.setState({
                    showLoading: false,
                    dataHotzone: nextProps.response
                })
            }
            if (nextProps.status === ACTIONS_SEARCH.GET_INFO_PLAYER_BATTER_BATTED_BALL_DIRECTION_SUCCESS) {
                this.setState({
                    showLoading: false,
                    dataBallDirection: nextProps.response
                })
            }
        }
    }

    render() {
        return (
            <div className="player">
                <div className="block-title">
                    <img src={this.state.imgTeam} alt="" onClick={() => this.navigateTeamReport()} />
                    <h2>{`坂本 ` + this.state.name ? this.state.name : ''}</h2>
                </div>
                <div className="block-general-info">
                    <div className="left">
                        <div className="wrap-img">
                            <img src="/img/action/staff_24px.svg" alt="Alt text" />
                        </div>
                        <div className="wrap-content">
                            <p className="bold-text">{this.state.nickname} | {this.state.position} | {this.state.player.bloodGroup} | {this.state.player.height}cm | {this.state.player.weight}kg | {this.state.player.old}歳</p>
                            <p className="light-text">{this.state.player.from} | {this.state.player.round}</p>
                            {
                                this.state.player.ability
                                    ? <p className="label">{this.state.player.condition}</p>
                                    : null
                            }
                            <p className="status">{this.state.player.status}</p>
                        </div>
                    </div>
                    <div className="right">
                    {(() => {
                        if (this.state.player.ability) {
                            return <>
                                <div className="area-1">
                                    <p className="bold-text">データ傾向</p>
                                    <div className="wrapper">
                                        <span className="blue-text">Poor</span>
                                        <span className="gray-text">Avg</span>
                                        <span className="red-text">Great</span>
                                    </div>
                                </div>
                                <div className="area">
                                    {Object.keys(this.state.player.ability).map((title, index) => {
                                        let value = this.state.player.ability[title]
                                        return(
                                            <div key={title}>
                                                <p className="light-text">{ title }</p>
                                                <div className="line">
                                                    <span className="dot"></span>
                                                    <span className="dot"></span>
                                                    <span className="dot"></span>
                                                </div>
                                                <p className="oval" data-percent={value*100} style={{left: value*100 +`%`, backgroundColor : value < 0.5 ? '#3D3DF2' : value > 0.5 ? '#FA3E3E' : '#6E7F8A'}}></p>
                                            </div>
                                        )
                                    })}
                                </div>
                            </>
                        }
                    })()}
                    </div>
                </div>
                <div className="block-tabs">
                    <TabPlayer />
                </div>
                <div className="block-content">
                    <Switch>
                    <Route path="/player/:id" exact render={() => <BasicInfomation playerId={this.props.match.params.id}
                            position={this.state.position == '投手' ? 'pitcher' : 'batter'}
                            playerInfo={this.state.playerInfo}
                            listYear={this.state.listYear}
                            dataPitcher1={this.state.dataPitcher1}
                            dataPitcher2={this.state.dataPitcher2}
                            dataHotzone={this.state.dataHotzone}
                            dataBallDirection={this.state.dataBallDirection}
                        />} />
                        <Route path="/player/:id/performance-by-condition"  render={ () => <PerformanceByCondition defaultTab={this.state.position == '投手' ? 'pitcher' : 'batter' } {...this.props} /> } />
                        <Route path="/player/:id/game-logs" component={GameLogs} />
                        <Route path="/player/:id/performance-by-year" component={PerformanceByYear} />
                        <Route path="/player/:id/topic/:topicId" component={TeamUserTopic} />
                        <Route path="/player/:id/add-topic" component={PlayerAddTopic} />
                        <Route path="/player/:id/pitcher" component={PlayerPitcher} />
                    </Switch>
                </div>

                <Loading show={this.state.showLoading} />
            </div>
        )
    }
}

const mapStateToProps = ({ playerPitchers }) => {
    return {
        response: playerPitchers.response,
        status: playerPitchers.status
    };
}

const mapDispatchToProps = dispatch => {
    return {
        GetPlayerPitchers: (id) => {
            dispatch(GetPlayerPitchers(id));
        },
        getSearchCommon: (t) => {
            dispatch(getSearchCommon(t))
        },
        getInfoPlayer: (id) => {
            dispatch(getInfoPlayer(id))
        },
        getYearData: () => {
            dispatch(getYearData())
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps, null, { pure : false })(Player);
